import React from "react";
import { BrowserRouter as Router, Route, Switch } from "react-router-dom";

//Redux
import { Provider } from "react-redux";
import store from "./redux/store";

import { SessionRoutes } from "./routes";
import RoutePrivate from "./routes/RoutePrivate";
import Navigation from "./routes/Navigation";

import ApplicationTheme from './components/Providers/ApplicationTheme'
import TranslationProvider from './components/Providers/TranslationProvider'

const App = () => {
  return (
    <ApplicationTheme>
      <TranslationProvider>
        <Router>
          <Provider store={store}>
            <Navigation />
          </Provider>
        </Router>
      </TranslationProvider>
    </ApplicationTheme>
  );
};

export default App;
